// extracted by mini-css-extract-plugin
export default {"text-input":"ue_cVWT","text-input__element":"A5jPhOZ","text-input__label":"fCPy9fi","text-input__icon":"jEfR305","text-input__input-message":"gUiWwHp","text-input--error":"_tzPNFa"};